import React from "react";
import type { TrailPoint } from "../../types/stats";

type TrailProps = {
  trails: Map<string, TrailPoint[]>;
  colorMap: Map<string, string>;
};

const Trail: React.FC<TrailProps> = ({ trails, colorMap }) => {
  return (
    <g>
      {Array.from(trails.entries()).map(([city, points]) => {
        if (points.length < 2) return null;
        const color = colorMap.get(city) ?? "#888";

        // セグメントごとに opacity をフェードアウト (新しいほど濃い)
        return (
          <g key={city}>
            {points.slice(1).map((pt, i) => {
              const prev = points[i];
              const opacity = ((i + 1) / points.length) * 0.5;
              return (
                <line
                  key={i}
                  x1={prev.x}
                  y1={prev.y}
                  x2={pt.x}
                  y2={pt.y}
                  stroke={color}
                  strokeWidth={1.5}
                  strokeOpacity={opacity}
                  strokeLinecap="round"
                />
              );
            })}
          </g>
        );
      })}
    </g>
  );
};

export default Trail;
